import {
  IconComfortArmchair16,
  IconFinanceWallet16,
  IconFunctionalCalendar16,
  IconProductBuilding16,
  IconPropertyCountryHouse16,
} from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './QuickFilters.css';
import { Filter } from './content';
import { NewbuildingEntryPointExperiment } from '../../containers/NewbuildingEntryPointExperiment';
import { IQuickFiltersRedesign, IQuickFiltersRedesignBlock } from '../../types/quickFilters';

const FILTER_CONFIG: ReadonlyArray<{
  key: keyof IQuickFiltersRedesign;
  Icon: React.ComponentType<{ color?: string }>;
  breakBefore?: boolean;
}> = [
  { key: 'flat_sale', Icon: IconFinanceWallet16 },
  { key: 'flat_rent', Icon: IconComfortArmchair16 },
  { key: 'posytochno', Icon: IconFunctionalCalendar16 },
  { key: 'newbuilding', Icon: IconProductBuilding16, breakBefore: true },
  { key: 'suburban', Icon: IconPropertyCountryHouse16 },
];

export interface IQuickFiltersProps {
  filters: IQuickFiltersRedesign;
  trackClickQuickFilter(key: string): void;
  isNewbuildingEntryEnabled: boolean;
}

export const QuickFilters: React.FC<IQuickFiltersProps> = ({
  filters,
  trackClickQuickFilter,
  isNewbuildingEntryEnabled,
}) => {
  return (
    <div className={styles['filters']} data-testid="QuickFilters">
      {FILTER_CONFIG.map(({ key, Icon, breakBefore }) => {
        const block = filters[key] as IQuickFiltersRedesignBlock<typeof key>;
        const filterElement = (
          <Filter
            queryString={block.queryString}
            title={block.title}
            icon={<Icon color="icon-main-default" />}
            trackClickQuickFilter={
              isNewbuildingEntryEnabled && key === 'newbuilding' ? () => {} : () => trackClickQuickFilter(block.key)
            }
          />
        );

        return (
          <React.Fragment key={key}>
            {breakBefore && <div className={styles['break']} />}
            {key === 'newbuilding' && isNewbuildingEntryEnabled ? (
              <NewbuildingEntryPointExperiment trackClickQuickFilter={() => trackClickQuickFilter(block.key)}>
                {filterElement}
              </NewbuildingEntryPointExperiment>
            ) : (
              filterElement
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};
